import { useState } from 'react'

export function useDocumentType() {
  const [documentType, setDocumentType] = useState<string | null>(null)

  return {
    documentType,
    setDocumentType
  }
}
